import { useEffect } from "react";

const SITE_NAME = "Yellow5";
const DEFAULT_IMAGE =
  "https://customer-assets-wrfwihn1.emergentagent.net/job_talent-hub-818/artifacts/8a3m5kio_Yellow5_Logo_Layout_Vecto-02.webp";

function upsertMeta(selector, attrs, content) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/**
 * Sets per-route SEO meta tags. Runs synchronously during first render so
 * react-snap captures the correct <title> and description in the pre-rendered
 * HTML.
 */
export default function usePageMeta({ title, description, image, lang }) {
  // Update synchronously on render so pre-render snapshots capture the values.
  if (typeof document !== "undefined") {
    if (title) {
      const fullTitle = title.includes(SITE_NAME) ? title : `${title} — ${SITE_NAME}`;
      document.title = fullTitle;
      upsertMeta('meta[property="og:title"]', { property: "og:title" }, fullTitle);
      upsertMeta('meta[name="twitter:title"]', { name: "twitter:title" }, fullTitle);
    }
    if (description) {
      upsertMeta('meta[name="description"]', { name: "description" }, description);
      upsertMeta('meta[property="og:description"]', { property: "og:description" }, description);
      upsertMeta('meta[name="twitter:description"]', { name: "twitter:description" }, description);
    }
    const img = image || DEFAULT_IMAGE;
    upsertMeta('meta[property="og:image"]', { property: "og:image" }, img);
    upsertMeta('meta[name="twitter:image"]', { name: "twitter:image" }, img);
    upsertMeta('meta[property="og:type"]', { property: "og:type" }, "website");
    upsertMeta('meta[property="og:site_name"]', { property: "og:site_name" }, SITE_NAME);
    upsertMeta('meta[name="twitter:card"]', { name: "twitter:card" }, "summary_large_image");

    if (typeof window !== "undefined" && window.location) {
      const base = process.env.REACT_APP_SITE_URL || window.location.origin;
      const url = base.replace(/\/$/, "") + window.location.pathname;
      upsertMeta('meta[property="og:url"]', { property: "og:url" }, url);
      upsertLink("canonical", url);
    }
    if (lang) {
      document.documentElement.setAttribute("lang", lang);
      upsertMeta('meta[property="og:locale"]', { property: "og:locale" }, lang === "fr" ? "fr_BE" : "en_US");
    }
  }

  // Keep effect too, for SPA navigations after hydration.
  useEffect(() => {
    /* no-op: already applied above */
  }, [title, description, image, lang]);
}
